import React from "react";
import { removeTaskerFromAuth } from "../../api/UserApi";
import Firebase from "../../firebasehelper";

const remove_icon = require("../../assets/media/stop.png");

class EditSuperAdminModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      email: "",
      uid: "",
    };
  }

  componentDidMount() {
    const { initialValues } = this.props;

    if (initialValues) {
      this.setState({
        username: initialValues.username || "",
        email: initialValues.email || "",
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { initialValues } = this.props;
    if (initialValues !== prevProps.initialValues) {
      if (initialValues) {
        this.setState({
          username: initialValues.username || "",
          email: initialValues.email || "",
          uid: initialValues.uid || "",
        });
      } else {
        this.setState({
          username: "",
          email: "",
          uid: "",
        });
      }
    }
  }
  onChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onSave = () => {
    const { username, email } = this.state;
    const { onSave } = this.props;
    onSave(username, email);
  };

  removeBrandAdmin = (uid) => {
    Firebase.removeAgency(uid);
    removeTaskerFromAuth(uid);
  };
  render() {
    const { username, email, uid } = this.state;
    const { hex, white } = this.props;
    return (
      <div
        className="modal fade"
        id="edit_super_admin"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit User</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1">
              <div className="form-group">
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  id="signup-username"
                  name="username"
                  placeholder="First Name"
                  onChange={this.onChangeHandler}
                  value={username}
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  className="form-control form-control-lg form-control-alt"
                  id="signup-email"
                  name="email"
                  placeholder="Email"
                  onChange={this.onChangeHandler}
                  value={email}
                />
              </div>
            </div>
            <div className="modal-footer d-flex justify-content-between">
              <img
                src={remove_icon}
                style={{ height: 20, marginRight: 15, cursor: "pointer" }}
                alt="remove"
                data-dismiss="modal"
                onClick={() => this.removeBrandAdmin(uid)}
              />
              <div className="d-flex">
                <button
                  type="button"
                  className="btn btn-brand-hex btn-white"
                  style={{
                    "--hover-text-color": white ? "white" : "black",
                    "--hover-color": hex,
                    backgroundColor: "white",
                    color: "black",
                  }}
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-green ml-3"
                  data-dismiss="modal"
                  onClick={this.onSave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default EditSuperAdminModal;



// WEBPACK FOOTER //
// ./src/components/EditSuperAdminModal/index.js